export const VITALS_FIELDS_NAMES = {
    DEVICE_NAME: "deviceName",
    TEST_NAME: "testName",
    TESTS: "tests"
}